import {Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';

import BusinessTransactionTable from './TransactionTable';
import type {BusinessTransactionsViewProps} from './types';

const BusinessTransactions: React.FC<BusinessTransactionsViewProps> = ({
  error,
  isLoading,
  isSearch,
  isPageReset,
  pageInfo,
  transactionList,
  handleFetchTransactions,
  actionButton,
}) => {
  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }

    // A failed request leaves the list empty, so without this arm it read as
    // "No Transactions found" (e.g. a search the server rejected).
    if (error) {
      return (
        <p
          className="mt-5 text-center text-red-500"
          data-cy="merchant-transactions-error-state"
        >
          Failed to load transactions.
        </p>
      );
    }

    if (!transactionList || !transactionList.length) {
      return (
        <div
          className="flex items-center gap-1 justify-center mt-5"
          data-cy="merchant-transactions-empty-state"
        >
          <p className="text-gray-800 dark:text-white">
            No Transactions found.
          </p>
        </div>
      );
    }

    return <BusinessTransactionTable items={transactionList} />;
  };

  return (
    <>
      {actionButton && <div className="flex justify-end">{actionButton}</div>}
      <section className="pt-5 md:pt-5">{renderList()}</section>
      {transactionList && transactionList.length ? (
        <Pagination
          onPageChange={
            handleFetchTransactions as PaginationProps['onPageChange']
          }
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </>
  );
};

export default BusinessTransactions;
